<template>
  <section class="cooperaListDiv">
    <viewTitle title="业务管理 / 合作单位管理 / 单位管理" :showReturn="false" />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button
          size="small"
          type="primary"
          @click="
            $router.push({
              path: '/rhqy/service/coopera/List/modify',
              query: {
                type: 'add'
              }
            })
          "
          >新建单位</el-button
        >
        <el-button type="primary" @click="importUser" size="small">
          导入文件
        </el-button>
        <exportB
          exportUrl="/api/queue/admin/export_unit"
          progressUrl="/api/queue/admin/get_unit_process"
          downLoadName="密码汇总"
          :text="'导出密码'"
          :paramsData="exportData"
        ></exportB>
        <!-- </div> -->
        <!-- </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl">类别: </span>
        <el-select
          class="ctl"
          clearable
          v-model="params.unit"
          placeholder="请选择类别"
          @change="changeUnit"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="item in unitOption"
            :key="item.id"
          ></el-option>
        </el-select>
        <span class="rectl">状态: </span>
        <el-select
          class="ctl"
          clearable
          @clear="params.state = 0"
          v-model="params.state"
          placeholder="请选择状态"
          @change="changeState"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="类别">
          <template slot-scope="scope">
            {{ scope.row.class_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="单位全称">
          <template slot-scope="scope">
            {{ scope.row.full_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="主要联系人">
          <template slot-scope="scope">
            {{ scope.row.contact || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template slot-scope="scope">
            {{ scope.row.phone || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1" class="color5E">正常</span>
            <span v-if="scope.row.state === 2" class="color67">已禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看单位</el-dropdown-item
                  >
                  <el-dropdown-item @click.native.stop="passWord(scope.row)"
                    >密码管理</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp(scope.row, 'forbid')"
                    v-if="scope.row.state === 1"
                    >禁用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp(scope.row, 'start')"
                    v-if="scope.row.state === 2"
                    >启用</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="moveUp(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <!-- 密码管理 -->
    <el-dialog
      :visible.sync="dialogParams.dialogPassShow"
      width="30%"
      title="密码管理"
    >
      <div>
        <el-form label-width="85px">
          <el-form-item label="单位类别：">
            {{ rowDataObj.class_name }}
          </el-form-item>
          <el-form-item label="当前单位：">
            {{ rowDataObj.full_name }}
          </el-form-item>
          <el-form-item label="企业账号：">
            {{ rowDataObj.phone }}
          </el-form-item>
          <el-form-item label="登录密码：">
            <span class="color99" v-if="rowDataObj.password === ''">
              用户已修改密码
            </span>
            <div v-else>
              <el-input
                v-model="dialogParams.pwd"
                style="width: 200px;margin-right: 25px;"
                readonly
                id="copyBoard"
              ></el-input>
              <el-button type="primary" @click="copyPassword" size="small">
                复 制
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.dialogPassShow = false" size="small">
          取 消
        </el-button>
        <el-button
          size="small"
          type="warning"
          @click="dialogParams.dialogResetPassShow = true"
          style="color: white;"
          >重置密码</el-button
        >
      </span>
      <el-dialog
        width="30%"
        title="确认提醒"
        :visible.sync="dialogParams.dialogResetPassShow"
        append-to-body
      >
        <span
          >确认要重置“<span class="color67">{{ rowDataObj.full_name }}</span
          >”的供应商登录密码吗？<br />重置后<span class="color67"
            >原有密码将立即失效</span
          >！</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="dialogParams.dialogResetPassShow = false"
            size="small"
          >
            取 消
          </el-button>
          <el-button type="primary" @click="confirmReset" size="small">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </el-dialog>

    <!-- 禁用  删除 -->
    <el-dialog :visible.sync="dialogParams.dialogMoveUpShow" width="30%">
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogMoveUpContent"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.dialogMoveUpShow = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">
            取 消
          </span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          size="small"
          :class="dialogParams.dialogType === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.dialogType === 'del' ? 'danger' : 'primary'"
          @click="confirmMoveUp"
          v-loading.fullscreen.lock="fullscreenLoading"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- <myUpload
      title="导入文件"
      :process="true"
      :show="dialogParams.dialogUploadShow"
      :templateUrl="templateUrl"
      uploadUrl="/management/web/expert/index?cmd=107"
      importUrl="/management/web/expert/index?cmd=105"
      failUrl="/management/web/expert/index?cmd=108"
      @updateVisible="
        val => {
          dialogParams.dialogUploadShow = val;
        }
      "
      @callback="getList"
    >
      <div slot="desc" style="line-height: 30px;margin-bottom: 13px;">
        请按以下步骤导入： <br />
        1. 下载模板并填写合作单位信息
        <span style="text-decoration: underline;color: #2acdcf;">下载模板</span>
        <br />
        2. 上传填写后的xls文件
      </div>
    </myUpload> -->

    <myUpload
      title="导入文件"
      :process="true"
      :show="uploadDialogParams.show"
      :templateUrl="uploadDialogParams.templateUrl"
      :uploadUrl="uploadDialogParams.uploadUrl"
      :importUrl="uploadDialogParams.importUrl"
      :progressUrl="uploadDialogParams.progressUrl"
      :otherParams="uploadDialogParams.otherParams"
      @updateVisible="importUpdateVisible"
      @callback="importUsercallback"
      :downloadDemoName="'单位导入模板'"
      :downloadFailFileName="'单位导入失败汇总'"
      :downloadSuccessFileName="'单位导入成功汇总'"
    >
      <span slot="desc">
        <span>
          3、仅支持模板信息格式，请勿填写其他数据内容
        </span>
        <br />
      </span>
    </myUpload>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
// import myUpload from "@/components/myUpload";
import myUpload from "@/components/myUploadNew";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";
import exportB from "@/components/export";

export default {
  data() {
    return {
      // module_name: "services-advice",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      params: {
        keyword: "", // 关键字搜索
        unit: "", // 单位
        state: 0 // 状态
      },
      templateUrl: "/management/web/expert/index?cmd=106",
      uploadVisible: false,
      maxSize: 0,
      tableData: [], // 表格数据
      unitOption: [
        {
          name: "全部",
          id: ""
        }
      ],
      exportData: {}, // 导出文件参数
      stateOption: ["全部", "正常", "已禁用"],
      dialogParams: {
        title: "确认提醒",
        dialogMoveUpShow: false, // 上移一位弹窗
        dialogType: "", // 弹窗类型
        dialogPassShow: false, // 密码弹窗显示
        dialogResetPassShow: false, // 重置密码确认弹窗显示
        dialogUploadShow: false // 导入文件
      },
      uploadDialogParams: {
        show: false,
        templateUrl: "/api/queue/admin/download_unit_model",
        uploadUrl: "/api/media/upload",
        importUrl: "/api/queue/admin/import_unit",
        progressUrl: "/api/queue/admin/get_unit_process",
        otherParams: {}
      },
      fullscreenLoading: false,
      dialogMoveUpContent: "",
      rowDataObj: {},
      toKeepAlivePath: "/rhqy/service/coopera/List/detail" // 当前路由访问某个页面时的不清除缓存
    };
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  components: {
    pagi,
    myUpload,
    viewTitle,
    exportB
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mounted() {
    // this.getList();
    this.getUnitList();
  },

  async activated() {
    this.getList();
  },

  created() {},

  methods: {
    importUser() {
      this.uploadDialogParams.show = true;
    },

    importUpdateVisible(val) {
      console.log(val);
      this.uploadDialogParams.show = val;
    },

    importUsercallback() {
      // this.paramsTable.page = 1;
      // this.fetchTableList();
      this.page = 1;
      this.getList();
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_unit",
        data: {
          state: this.params.state,
          keyword: this.params.keyword,
          class_id: this.params.unit,
          // page_size: ""
          page_size: this.pageSize,
          page: this.page
        }
      });
      this.exportData = {
        class_id: this.params.unit,
        state: this.params.state,
        keyword: this.params.keyword
      };
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 获取单位列表
    async getUnitList() {
      await this.$common
        .http({
          url: "/api/queue/admin/query_unit_class",
          data: {
            state: 0,
            keyword: "",
            class_id: "",
            page_size: ""
          }
        })
        .then(res => {
          console.log(res.data.data);
          res.data.data.data.forEach(item => {
            this.unitOption.push({
              name: item.name,
              id: item.id
            });
          });
        });
    },

    // 修改状态
    changeState(val) {
      this.page = 1;
      this.params.state = val;
      this.getList();
    },

    // 修改单位
    changeUnit(str) {
      this.page = 1;
      this.params.unit = str;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/rhqy/service/coopera/List/detail",
        query: {
          id: row.id
        }
      });
    },

    // 密码管理
    passWord(row) {
      this.rowDataObj = row;
      this.dialogParams.pwd = row.password;
      this.dialogParams.dialogPassShow = true;
    },

    // 复制密码
    copyPassword() {
      var text = document.getElementById("copyBoard");
      text.select(); // 选择对象
      document.execCommand("Copy");
      this.$message.success("已复制密码到剪切板!");
    },

    // 确认重置密码
    confirmReset() {
      this.$common
        .http({
          url: "/api/queue/admin/reset_password",
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          if (res.data.data) {
            this.dialogParams.pwd = res.data.data;
            this.rowDataObj.password = res.data.data;
            setTimeout(() => {
              var text = document.getElementById("copyBoard");
              text.select(); // 选择对象
              document.execCommand("Copy");
              this.$common.pcToastSuccess("密码重置成功并已复制到粘贴板!");
            }, 1000);
          }
          this.getList();
          this.dialogParams.dialogResetPassShow = false;
        });
    },

    // 禁用/删除
    moveUp(row, tag) {
      this.dialogParams.dialogType = tag;
      this.dialogParams.dialogMoveUpShow = true;
      this.dialogParams.title = "确认提醒";
      this.rowDataObj = row;
      if (tag === "forbid") {
        this.dialogMoveUpContent = `确定要禁用“<span class="color67">${this.rowDataObj.full_name}</span>”的登录账户？<br />禁用后该单位不可登录，不可发起预约业务！`;
      } else if (tag === "start") {
        this.dialogMoveUpContent = `确定要启用“<span class="color67">${this.rowDataObj.full_name}</span>”的登录账户？`;
      } else if (tag === "del") {
        this.dialogMoveUpContent = `确定要删除“<span class="color67">${this.rowDataObj.full_name}</span>”的账户信息？<span class="color67">删除后不可恢复</span>！`;
      }
    },

    // 确认操作
    confirmMoveUp() {
      if (this.dialogParams.title === "确认提醒") {
        this.dialogParams.dialogMoveUpShow = false;
        let url = "";
        if (this.dialogParams.dialogType === "del") {
          url = "/api/queue/admin/del_unit";
        } else if (
          this.dialogParams.dialogType === "start" ||
          this.dialogParams.dialogType === "forbid"
        ) {
          url = "/api/queue/admin/enable_unit";
        }
        this.$common
          .http({
            url: url,
            data: {
              id: this.rowDataObj.id
            }
          })
          .then(res => {
            console.log(res);
            // this.dialogMoveUpContent = `已成功删除“<span class="color67">${this.rowDataObj.full_name}</span>”的账户信息。`;
            if (this.dialogParams.dialogType === "del") {
              this.$common.pcToastSuccess(
                `已成功删除“${this.rowDataObj.full_name}”的账户信息。`
              );
            } else if (this.dialogParams.dialogType === "forbid") {
              this.$common.pcToastSuccess(
                `已成功禁用“${this.rowDataObj.full_name}”的账户信息。`
              );
            } else if (this.dialogParams.dialogType === "start") {
              this.$common.pcToastSuccess(
                `已成功启用“${this.rowDataObj.full_name}”的账户信息。`
              );
            }
            // this.dialogParams.dialogMoveUpShow = true;
            // this.dialogParams.title = "操作成功";
            this.getList();
            // setTimeout(() => {
            //   this.dialogParams.dialogMoveUpShow = false;
            // }, 1500);
          });
      } else {
        this.dialogParams.dialogMoveUpShow = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.cooperaListDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 13px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
</style>
